import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Button';
import { formatClassName } from '../utils';

export const SSOButton = ({ className, disabled, fixedSize, icon, imgUrl, rounded, ...otherProps }) => {
  const buttonClass = formatClassName([
    className,
    'btn-sso',
    'btn-block',
    'large',
    {
      'fixed-size': fixedSize,
      'with-icon': !!icon,
      'with-image-icon': !!imgUrl,
      rounded,
    },
  ]);

  const buttonStyle =
    imgUrl && !disabled
      ? {
          backgroundImage: `url(${imgUrl})`,
        }
      : null;

  return (
    <Button
      {...otherProps}
      style="secondary"
      className={buttonClass}
      cssStyle={buttonStyle}
      icon={imgUrl ? null : icon}
      disabled={disabled}
      renderAsLegacy
    />
  );
};

SSOButton.propTypes = {
  ...Button.propTypes,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fixedSize: PropTypes.bool,
  icon: PropTypes.string,
  imgUrl: PropTypes.string,
  rounded: PropTypes.bool,
};

SSOButton.defaultProps = {
  fixedSize: false,
  rounded: false,
  disabled: false,
};
